import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/webinars/ai-in-life-sciences-compliant-ai-gxp")({
  head: () => buildRouteHead("/en/webinars/ai-in-life-sciences-compliant-ai-gxp", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/webinars/ai-in-life-sciences-gxp-compliance", replace: true });
  },
});
